import React, { useState } from 'react';
import { Icon } from '@scuf/common';
import axios from '../../../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS } from '../../../constants/constants';

interface AttachmentDownloadProps {
  opportunityId: number;
  fileName: string;
  storedFileName?: string;
}

export const AttachmentDownload = ({ opportunityId, fileName, storedFileName }: AttachmentDownloadProps) => {
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const download = async () => {
    setLoading(true);
    setFailed(false);
    try {
      // SECURITY_NOTE: Use the authenticated API client and encode attachment identifiers.
      const response = await axios.get(
        `${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}/download`,
        { params: { file_name: fileName, stored_file_name: storedFileName }, responseType: 'blob' }
      );
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      try {
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
      } finally {
        link.remove();
        URL.revokeObjectURL(url);
      }
    } catch {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="attachment-download"
        aria-label={`Download ${fileName}`}
        title={storedFileName ? `Download ${fileName}` : 'Download unavailable: missing attachment identifier'}
        disabled={loading || !storedFileName}
        onClick={download}
      >
        <Icon name="cloud-download" root="common" size="small" />
        {loading && 'Downloading...'}
      </button>
      {failed && <span className="action--error-text" role="alert">File download failed. Please retry.</span>}
    </>
  );
};
